export default __webpack_public_path__ + "static/media/Financial-Results.27259abb.pdf";